import styled from "styled-components";

export const Container = styled.section`
  padding: 60px 20px;
  color: var(--blue);

  h2 {
    text-align: center;
    font-size: 5rem;
    margin-bottom: 50px;
    color: var(--white);
  }

  .timeline {
    display: flex;
    flex-direction: column;
    gap: 60px;
  }

  .experience-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: linear-gradient(to right, var(--black), var(--green));
    padding: 40px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 191, 255, 0.2);
    gap: 30px;
    align-items: center;
    overflow: hidden;
  }

  .experience-card.row-reverse {
    flex-direction: row-reverse;
    background: linear-gradient(to left, var(--black), var(--green));
  }

  .text-section {
    flex: 1;
    min-width: 0;
  }

  .preview {
    flex: 1;
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 280px;
    object-fit: contain;
    border-radius: 12px;
    border: 2px solid var(--green);
  }

  .header {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
  }

  .logo {
    width: 60px;
    height: 60px;
    object-fit: contain;
    border-radius: 8px;
  }

  .company {
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--blue);
    display: block;
  }

  .date {
    font-size: 0.95rem;
    color: var(--pink);
  }

  h3 {
    font-size: 1.6rem;
    margin-bottom: 5px;
    color: var(--green);
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;
    margin-top: 15px;
  }

  ul li {
    font-size: 2rem;
    line-height: 2;
    color: var(--pink);
    margin-bottom: 10px;
  }

  .desc p {
    font-size: 1.5rem;
    line-height: 1.75;
    color: var(--pink);
    margin-bottom: 10px;
  }

  .desc hr {
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    margin: 12px 0;
  }

  /* ✅ Mobile Fixes */
  @media (max-width: 768px) {
    .experience-card,
    .experience-card.row-reverse {
      flex-direction: column !important;
      padding: 20px;
    }

    .preview {
      max-height: 180px;
      margin-top: 20px;
    }

    .header {
      flex-direction: column;
      align-items: flex-start;
    }

    .company,
    .date {
      font-size: 1rem;
    }

    h3 {
      font-size: 1.4rem;
    }

    .desc p {
      font-size: 1.2rem;
    }

    ul li {
      font-size: 1.3rem;
    }
  }
`;
